export default __webpack_public_path__ + "static/media/cl19.8501a041.webp";